<script lang="ts" context="module">
  import { z } from 'zod';

  export const JobLocationTheme = z.object({
    color: z.string()
  });
</script>

<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';

  export let isRemote: boolean;
  export let location: string;

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(14, 14))
    .addFluid('gap', toFluidVarInput(8, 8))
    .toCSS();

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

<div class={responsiveVars}>
  {#if isRemote}
    {#if brandReskinEnabled}
      <FontSizeDecorator size="caption">
        <p data-testid="is-remote-job" class="remote-label">Remote</p>
      </FontSizeDecorator>
    {:else}
      <p data-testid="is-remote-job">Remote</p>
    {/if}
    <div class="dot" />
  {/if}

  {#if brandReskinEnabled}
    <FontSizeDecorator size="caption">
      <p data-testid="job-location">{location}</p>
    </FontSizeDecorator>
  {:else}
    <p data-testid="job-location">{location}</p>
  {/if}
</div>

<style lang="scss">
  div {
    font-family: var(--font-family-primary);
    font-size: var(--font-size);
    font-weight: 500;
    line-height: 130%;
    display: flex;
    align-items: center;
    gap: var(--gap);
  }

  .dot {
    display: inline-block;
    width: 3px;
    height: 3px;
    background: var(--theme-job-location-color, var(--twist-color-gray-0));
  }

  p {
    color: var(--theme-job-location-color, var(--twist-color-gray-0));
  }

  .remote-label {
    font-weight: 600;
  }
</style>
